module.exports = __webpack_public_path__ + "img/material.51dfbc62.png";